import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense(
	'Ngo9BigBOggjHTQxAR8/V1NMaF1cW2hIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEBjW31fcXdXR2BfV0JwXA=='
);

// disable debug data on prod profile to improve performance)
if (environment.DEBUG_INFO_ENABLED) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule, { preserveWhitespaces: true })
	.then(() => console.log('Application started'))
	.catch((err) => console.error(err));
